import { BottomSpacer, TopSpacer } from "../spacer";

import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import SignOutButton from "../sign-out";
import Customer from "./customer/customer-portal";
import AdminLayout from "./admin/admin-layout";

export default function Dashboard({ user, role }: any): React.ReactElement {
  return (
    <div>
      {role === "admin" ? (
        <AdminLayout user={user} role={role} />
      ) : (
        <>
          <TopSpacer />
          <br />
          <SignedIn>
            <h1>Hi, {user?.firstName} 👋🏼</h1>
            <br />
            <h2 style={{ width: "90%", margin: "auto" }}>
              Welcome to the Teck Engineers Customer Portal
            </h2>
            <Customer />
            <SignOutButton />
          </SignedIn>
          <SignedOut>
            <RedirectToSignIn />
          </SignedOut>
          <BottomSpacer />
          <BottomSpacer />
        </>
      )}
    </div>
  );
}
